// extracted by mini-css-extract-plugin
var _1 = "cARVf";
var _2 = "EE88M";
var _3 = "bnlmN";
var _4 = "oqtY4";
export { _1 as "attribute", _2 as "base", _3 as "edit", _4 as "emptyValue" }
